var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactIconFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 0.625H11.375C12.332 0.625 13.125 1.41797 13.125 2.375V11.125C13.125 12.1094 12.332 12.875 11.375 12.875H7.84766V8.91016H9.73438L10.1172 6.75H7.84766V6.01172C7.84766 4.86328 8.28516 4.42578 9.43359 4.42578C9.78906 4.42578 10.0625 4.45312 10.2266 4.45312V2.53906C9.92578 2.42969 9.16016 2.34766 8.72266 2.34766C6.37109 2.34766 5.30469 3.46875 5.30469 5.84766V6.75H3.85547V8.91016H5.30469V12.875H2.625C1.64062 12.875 0.875 12.1094 0.875 11.125V2.375C0.875 1.41797 1.64062 0.625 2.625 0.625Z",
    fill: "#8791B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIconFacebook);
export default __webpack_public_path__ + "static/media/contact-icon-facebook.ec0208808f765d3e21fdc9a777dc8fd9.svg";
export { ForwardRef as ReactComponent };